import { FormControl, Grid, OutlinedInput, Typography, useTheme } from '@mui/material';
import React from 'react';

type Props = {
  address: string;
  handleDetailsChange: (fieldName: any, newValue: any) => void;
  hasPermission: boolean;
};

const SettingsOrgaddress = ({ address, handleDetailsChange, hasPermission }: Props) => {
  const theme = useTheme();   
  const isDarkMode = theme.palette.mode === 'dark';
  return (
    <Grid container spacing={2} sx={{ alignItems: 'center' }}>
      <Grid item xs={12} md={4}>
        <Typography variant="h5" sx={{ fontSize: '14px' }}>
          Address
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <FormControl sx={{ width: '100%' }} variant="outlined">
          <OutlinedInput
             sx={{
              fontSize: "0.75rem",
              "& .MuiInputBase-input::placeholder": {
                color: isDarkMode ? theme.placeholder.dark : theme.placeholder.light,
                opacity: 1,
              },
            }}
           
            id="outlined-adornment-weight"
            placeholder="Address"
            value={address}
            onChange={e => handleDetailsChange('address', e.target.value)}
            multiline
            aria-describedby="outlined-weight-helper-text"
            inputProps={{
              'aria-label': 'weight',
            }}
            disabled={!hasPermission}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default SettingsOrgaddress;
